import { SelectOptionValue } from "../hotel-result";
import { SelectOption } from "./SearchAvailableRoom";

export function findOption(
  opts: SelectOption[] | { label: string; options: SelectOption[] }[],
  val?: string,
): SelectOptionValue | null {
  if (!val) return null;

  if (Array.isArray(opts) && opts.length > 0 && "value" in opts[0]) {
    return (opts as SelectOptionValue[]).find((o) => o.value === val) ?? null;
  }

  if (Array.isArray(opts) && opts.length > 0 && "options" in opts[0]) {
    for (const g of opts as { options: SelectOptionValue[] }[]) {
      const f = g.options.find((o) => o.value === val);
      if (f) return f;
    }
  }

  return null;
}
